import React from 'react';
import { BsTwitterX } from 'react-icons/bs';
import { FaSteam, FaTwitch, FaVk, FaYoutube } from 'react-icons/fa';

import { User } from '@/types';

interface UserSocials {
  userData: User;
}
const UserSocials: React.FC<UserSocials> = ({ userData }) => {
  return (
    <div className="flex items-center gap-x-5">
      {userData.vk && (
        <a
          className="hover: inline-block cursor-pointer text-muted-foreground"
          target="_blank"
          href={`https://vk.com/${userData.vk}`}
          rel="noreferrer"
        >
          <FaVk className="h-6 w-6" />
        </a>
      )}
      {userData.youtube && (
        <a
          className="hover: inline-block cursor-pointer text-muted-foreground"
          target="_blank"
          href={`https://youtube.com/channel/${userData.youtube}`}
          rel="noreferrer"
        >
          <FaYoutube className="h-6 w-6" />
        </a>
      )}
      {userData.twitch && (
        <a
          className="hover: inline-block cursor-pointer text-muted-foreground"
          target="_blank"
          href={`https://twitch.tv/${userData.twitch}`}
          rel="noreferrer"
        >
          <FaTwitch className="h-6 w-6" />
        </a>
      )}
      {userData.twitter && (
        <a
          className="hover: inline-block cursor-pointer text-muted-foreground"
          target="_blank"
          href={`https://x.com/${userData.twitter}`}
          rel="noreferrer"
        >
          <BsTwitterX className="h-6 w-6" />
        </a>
      )}
      <a
        className="hover: inline-block cursor-pointer text-muted-foreground"
        target="_blank"
        href={`https://steamcommunity.com/profiles/${userData.steamid}`}
        rel="noreferrer"
      >
        <FaSteam className="h-6 w-6" />
      </a>
    </div>
  );
};

export { UserSocials };
